import { UserData } from '@src/types'

export const transformUserData = (userData: UserData) => {
  if (!userData) return

  return {
    email: userData.email,
    phone: userData.phone,
    firstname: `${userData.firstName} ${userData.lastName}`
  }
}
